
const _ = require('lodash');

const util = require('util');

const FormControllerBase = require('./base');
const CallbackFormModel = require('./callback-model');


function CallbackFormController () {
	FormControllerBase.apply(this, arguments);
}

util.inherits(CallbackFormController, FormControllerBase);

_.extend(CallbackFormController.prototype, {
	_modelConstructor: CallbackFormModel,
	_modalTemplate: require('../templates/callback.html')(),
	_successModalTemplate: require('../templates/callback-success.html')(),
	_title: 'Форма заказа обратного звонка',
});

module.exports = CallbackFormController;

